import { useAuthContext } from '@ascension/ascensionid-sdk';
import React from 'react';
import { useSelector } from 'react-redux';
import { UserProfileDetailsSelector } from '@store/selectors/UserProfileSelector';
import { buildPendoVisitor } from '@utilities/pendo/usePendoInitialization';
import { getLoginSessionId } from '@utilities/loginSession/loginSession';
import { useSsmUiFlags } from '../useSsmUiFlags/useSsmUiFlags';

const SSM_CONFIG = 'SSM_CONFIG';

interface MessageController {
	isConnected: boolean;
	send: (type: string, payload: unknown, version?: number) => void;
}

export const useSsmConfigBridge = ({ isConnected, send }: MessageController) => {
	const { authResponse } = useAuthContext();
	const accessToken = authResponse?.accessToken;
	const userProfile = useSelector(UserProfileDetailsSelector);
	const { wEnableFaxManagementSplitDoc, wEnableFaxManagementDocActivity } = useSsmUiFlags();

	// AuthBase starts a fresh session from the redirect hash; keep bridge delivery after that effect
	// or this can send the previous login-session id before AuthBase rotates it.
	React.useEffect(() => {
		if (!isConnected || !accessToken || !userProfile?.username) return;

		const pendoVisitor = buildPendoVisitor(userProfile);

		send(SSM_CONFIG, {
			token: accessToken,
			apiKey: window.config.API_KEY_1,
			ldFlags: { wEnableFaxManagementSplitDoc, wEnableFaxManagementDocActivity },
			loginSessionId: getLoginSessionId(),
			userConfig: { pendoVisitor },
		});
	}, [
		isConnected,
		accessToken,
		userProfile,
		send,
		wEnableFaxManagementSplitDoc,
		wEnableFaxManagementDocActivity,
	]);
};
